import React from "react";

import PageWrapper from "../components/PageWrapper";
import ProtectedRoute from "../components/ProtectedRoute";
import CareerPath from "../sections/landing4/CareerPath";
import CTA from "../sections/landing4/CTA";
import Seo from "../components/Seo";

const CareerPathPage = () => {
  return (
    <>
      <Seo
        title="DevOps Career Path"
        description="Interactive roadmap from junior to staff DevOps engineer. Skills, resources, and labs at every level."
        pathname="/career-path"
      />
      <PageWrapper>
        <ProtectedRoute requiredRole="public">
          <CareerPath />
        </ProtectedRoute>
        <CTA />
      </PageWrapper>
    </>
  );
};
export default CareerPathPage;
